module.exports = __webpack_public_path__ + "img/confirmation-success.6021985a.svg";